import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MaquinaService } from '../services/maquina.service';
import { MaquinaEffects } from './maquina.effects';
import { maquinaReducer } from './maquina.reducer';
import { MaquinasFeatureKey } from './maquina.state';

@NgModule({
	imports: [
		CommonModule,
        StoreModule.forFeature(MaquinasFeatureKey, maquinaReducer),
		EffectsModule.forFeature([MaquinaEffects]),
		
	
	],
	providers: [MaquinaService]
})
export class MaquinasStoreModule {}